export const DocumentsIcon = ({ className }) => {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9743_11360)">
        <path
          d="M62.5 70H17.5C16.837 70 16.2011 69.7366 15.7322 69.2678C15.2634 68.7989 15 68.163 15 67.5V12.5C15 11.837 15.2634 11.2011 15.7322 10.7322C16.2011 10.2634 16.837 10 17.5 10H47.5L65 27.5V67.5C65 68.163 64.7366 68.7989 64.2678 69.2678C63.7989 69.7366 63.163 70 62.5 70Z"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.5 10V27.5H65"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30 42.5H50"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30 52.5H50"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9743_11360">
          <rect width={80} height={80} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
